import { Alert, Button, Link, Text } from '@nimbus-ds/components';
import { useIsInAppBrowser } from 'App/hooks';
import { Stack } from 'commons/components';
import { useGoToPlans } from 'commons/hooks/useGoToPlans';
import { useIsMobileDevice } from 'domains/Auth/hooks';
import useTranslationOnline from 'domains/Online/useTranslationOnline';
import { useGoToThemesStore } from '../hooks';

interface UpgradePlanAlertProps {
  show: boolean;
}

export function UpgradePlanAlert({ show }: Readonly<UpgradePlanAlertProps>) {
  const t = useTranslationOnline('themesPage.planAlert');
  const { handleGoToPlans } = useGoToPlans();
  const handleClickViewThemes = useGoToThemesStore();
  const isInAppBrowserOpen = useIsInAppBrowser();
  const isMobileDevice = useIsMobileDevice();
  const isWebVersion = !isMobileDevice && !isInAppBrowserOpen;

  return (
    <Alert show={show} appearance="primary" title={t('title')}>
      <Stack column align="flex-start">
        <Text>{t('subtitle')}</Text>
        <Stack>
          <Button onClick={handleGoToPlans}>
            {isWebVersion ? t('upgrade') : t('goToPlans')}
          </Button>
          <Link onClick={handleClickViewThemes}>{t('viewThemes')}</Link>
        </Stack>
      </Stack>
    </Alert>
  );
}
